export default {
  BASE_URL: "https://api.rajaranicouture.co.in",  //  ---- live
  // BASE_URL: "https://localhost:7253",   // ----- local
}